"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
var axiosClient = /** @class */ (function () {
    function axiosClient(_a) {
        var baseURL = _a.baseURL, headers = _a.headers, retries = _a.retries, retriesDelay = _a.retriesDelay, _b = _a.timeout, timeout = _b === void 0 ? 5000 : _b;
        this.instance = axios_1.default.create({ baseURL: baseURL, timeout: timeout, headers: headers });
        this.retriesDelay = retriesDelay || 2;
        this.retries = retries || 2;
    }
    axiosClient.prototype.setHeader = function (key, value) {
        this.instance.defaults.headers.common[key] = value || "";
    };
    axiosClient.prototype.makePostRequest = function (requestObject) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.makeRequest(requestObject)];
                    case 1:
                        response = _a.sent();
                        console.log("PostRequest Response", response);
                        return [2 /*return*/, { submitted: true }];
                    case 2:
                        error_1 = _a.sent();
                        console.log("PostRequest Error", error_1);
                        return [2 /*return*/, { submitted: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    axiosClient.prototype.makeRequest = function (_a, activeRetryCount) {
        var url = _a.url, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var retryCount, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        retryCount = Number(activeRetryCount) || 0;
                        if (retryCount > this.retries) {
                            throw Error("Unable to make the request (total retry: " + retryCount + ")");
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 2, , 5]);
                        return [2 /*return*/, this.instance.post(url, data)];
                    case 2:
                        e_1 = _b.sent();
                        retryCount++;
                        return [4 /*yield*/, delay(1000 * Math.pow(this.retriesDelay, retryCount))];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.makeRequest({ url: url, data: data }, retryCount)];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return axiosClient;
}());
exports.default = axiosClient;
